module.exports = __webpack_public_path__ + "img/logo-color.812b3234.png";